/*印地语*/
const hi_IN = {
  langsOptions: {
    en_US: 'इंग्लिश',
    hi_IN: 'हिंदी',
    zh_CN: 'चिनेसे'
  },
  ThirdParty: {
    title: 'उल्लेखनीय है',
    ways: {
      Google: 'गूगल',
      Facebook: 'फेसबुक',
      Twitter: 'ट्विटर'
    }
  },
  pageTab: {
    Home: 'होमपेज',
    Discounts: 'प्रोमोशंस',
    Deposit: 'डिपॉजिट्स ',
    Service: 'ग्राहक सेवा',
    My: 'माय',
    tab1Txt: 'क्रिकेट',
    tab2Txt: 'खेल',
    tab3Txt: 'खेल',
    tab4Txt: 'टीम',
    tab5Txt: 'प्रोफाइल'
  },
  header: {
    login: 'लॉगिन',
    register: 'रजिस्टर',
    service: 'कस्टमर  सपोर्ट  सेण्टर',
  },
  newsTitle: ['जमा सूचना', 'रखरखाव का नोटिस', 'असामान्य घटना', 'विशेष प्रोमो', 'विजेता घोषित', 'विशेष सूचना',
    'विशेष अनुशंसा करता है'
  ],
  register: {
    username: 'अकाउंट',
    // usernamePlace: '6-12 अक्षर or संख्या या एक संयोजन',
    usernamePlace: '6 ~ 12 अल्फ़ान्यूमेरिक संयोजन',
    usernamePlace1: 'कृपया उपयोगकर्ता नाम दर्ज करें ',
    passwordPlace1: 'कृप्या पास्वर्ड भरो ',
    userError: 'कृपया 6 ~ 12 अक्षर, संख्या या अक्षरों और संख्याओं का एक संयोजन दर्ज करें',
    password: 'कुंजिका',
    passwordPlace: '6-12 अक्षर or संख्या या एक संयोजन',
    passwordError: 'कृपया 6 ~ 12 अक्षरों, संख्याओं या अक्षरों और संख्याओं के संयोजन के साथ एक पासवर्ड दर्ज करें',
    repeatPassword: 'कन्फर्म  पासवर्ड',
    repeatPasswordPlace: 'प्लीज  टाइप  पासवर्ड  अगेन',
    phone: 'सेल फ़ोन नंबर',
    phonePlace: 'प्लीज  टाइप  सेल  फ़ोन  नंबर',
    phoneTips: 'प्लीज प्रोवाइड करेक्ट सेल फ़ोन नंबर तो ऑथेंटिकेट योर आइडेंटिटी',
    agentCode: 'एफिलिएट ईद',
    agentCodePlace: 'लीव थिस फील्ड एम्प्टी िफ़ नो एफिलिएट ईद',
    vrifyCode: 'वेरिफिकेशन कोड',
    vrifyCodePlace: 'कृपया सही सत्यापन कोड दर्ज करें',
    rule: 'मैं सहमत हूँ',
    userRegistrationAgreement: '「उपयोगकर्ता पंजीकरण समझौता」',
    loginbtn: 'सिग्न उप नाउ',
    existingAccount: 'हैवे ान अकाउंट ?',
    confirmTitle: 'सक्सेस्स्फुल्ली रजिस्टर्ड . यू मई क्लेम योर कॅश बोनस वन्स रियल -नाम वेरिफिकेशन कम्प्लेटेड .',
    authenticateNow: 'गेट वेरिफ़िएड नाउ',
    certifyLater: 'गेट वेरिफ़िएड लेटर',
    successTips: 'कॉंग्रट्स! सक्सेस्स्फुल्ली रजिस्टर्ड',
    successTips2: 'GAMESTECH में आपका स्वागत है!',
    bankPart1: 'यू कैन आल्सो..',
    bankPart2: 'बाँध बैंक अकाउंट',
    bankPart3: 'अवेलेबल फॉर यू तो विथड्रॉ मनी अन्य्तिमे यू लिखे !',
    startGame: 'खेल खेलो',
    startDeposit: 'डिपाजिट',
    remember: 'रेमेम्बेर में',
    require: 'रिक्वायर्ड',
    noRequire: 'नॉट रिक्वायर्ड',
    realName: 'रियल नाम  ',
    realNamePlace: 'प्लीज एंटर रियल नाम',
    realNamePlace1: 'कृपया बीच में केवल एक स्थान के साथ संख्या या अक्षर दर्ज करें',
    qq: 'कक',
    qqPlace: 'प्लीज एंटर कक अकाउंट',
    qqError: 'कृपया QQ नंबर दर्ज करें जिसका पहला अंक 0 नहीं हो सकता है',
    wechat: 'वेचत ',
    wechatPlace: 'प्लीज  एंटर  वेचत',
    wechatError: 'एक अक्षर से शुरू होने वाले 5 या अधिक अक्षर, संख्या, अंडरस्कोर या माइनस संकेत',
    email: 'ईमेल ',
    emailPlace: 'प्लीज एंटर करेक्ट ईमेल',
    withdrawPassword: 'विथड्रावल पासवर्ड',
    withdrawPasswordPlace: 'प्लीज एंटर विथड्रावल पासवर्ड',
    sendCode: "सत्यापन ",
    phoneCode: "6 अंक ओटीपी",
    loginTips1: "नई  कस्टमर ? ",
    loginTips2: "ओपन  नई  अकाउंट ",
    loginTips3: "इन  आर्डर  तो  प्लेस  बेट (s) यू  मस्ट  बे  ा  रजिस्टर्ड  यूजर ",
    loginTips4: "बी  प्रोसीडिंग  यू  कन्फर्म  यू  अरे  18 इयर्स  ऑफ़  आगे  और  ओल्डर .",
    loginTips5: "लेट 'स  एक्टिवटे  योर  अकाउंट ! ",
    loginTips6: "यू  हैवे  सक्सेस्स्फुल्ली  क्रिएटेड  योर  अकाउंट !  तो  अनलॉक  योर  वेलकम ऑफर  एंड  स्टार्ट  प्लेइंग , चेक  योर  ईमेल  एंड  क्लिक  थे  एक्टिवेशन  लिंक .",
    registerBtn: 'सिग्न उप नाउ ',
    registerBtn1: 'सिग्न उप नाउ ',
    signUp: 'ओपन योर अकाउंट ',
    signUp1: 'अभी साइनअप करें',
    login: 'अब साइन इन करो'
  },
  ValidTips: {
    name: 'रियल नाम वेरिफिकेशन दोने，',
    phone: 'फ़ोन वेरिफिकेशन दोने，',
    email: 'ईमेल वेरिफिकेशन दोने，',
    conactService: 'प्लीज कांटेक्ट लिवेचत फॉर अन्य चेंज ！',
    noPhone: 'इनवैलिड फ़ोन वेरिफिकेशन ,प्लीज प्रोसीड फॉर मैन्युअल वेरिफिकेशन ',
    noDrawPwd: 'नो  विथड्रावल  pwd, प्लीज  सेट  उप ',
    noPhoneDrawPwd: 'इनवैलिड फ़ोन वेरिफिकेशन,नो विथड्रावल',
	noPhoneDrawPwd2: "कृपया बैंक खाते को बाँधने से पहले मोबाइल नंबर और निकासी पिन भरें",
  },
  download: {
    title: '',
    app: 'ऐप',
    appDownload: 'मोबाइल ऐप',
    subTitle: 'सेफ्टी | रिलाएबल | फ़ास्ट',
    downloadNow: 'डाउनलोड'
  },
  nav: {
    HotGame: 'टॉप हिट्स',
    Sport: 'स्पोर्ट्सबुक',
    Live: 'लाइव गेम्स',
    CatchFish: 'मछली',
    Slot: 'स्लॉट्स',
    Rummy:'Rummy',
    Lottery: 'लाटरी',
    CardGame: 'कार्ड गेम',
    vip:'VIP',
    discount:'Promotions',
    Commission:'Commission',
    Blog:'Blog',
  },
  agency: {
    title: 'ाफ़िलिटस प्रोग्राम',
    affiliatesAgree: 'ाफ़िलिटस एग्रीमेंट',
    agencyLogin: 'ाफ़िलिटस लॉगिन',
    agencyRegister: 'रजिस्टर अस ाफ़िलिटस'
  },
  others: {
    save: 'सहेजें ',
    click: "क्लिक",
    success: "सफलता",
    total: "कुल",
    all: 'सबें',
    selectLang: 'एक भाषा चुनें',
    CustomerService: 'कांटेक्ट कस्टमर सपोर्ट',
    roger: 'कॉपी तहत',
    monetaryUnit: '₹',
    loadingTxt: 'लोडिंग',
    refreshTxt: 'रिफ्रेशिंग',
    loadmore: 'क्लिक तो लोड मोरे',
    noData1: 'नो मोरे डाटा',
    noData2: 'सॉरी …. नो डाटा',
    noData3: 'और कोई रिकॉर्ड नहीं',
    confirm: 'कन्फर्म',
    cancel: 'कैंसिल',
    Delete: 'डिलीट',
    next: 'नेक्स्ट',
    tips: 'नोटिफिकेशन',
    refreshSuccess: 'सक्सेस्स्फुल्ली रिफ्रेश',
    copy: 'कॉपी',
    copySuceess: 'सक्सेस्स्फुल्ली कपैड',
    select: 'प्लीज सेलेक्ट ',
    select1: 'सेलेक्ट',
    finish: 'फिनिश्ड',
    close: 'बंद करे',
    search: 'खोज',
    searchGame: 'खोज का खेल',
    reset: 'रीसेट',
    startTime: 'स्टार्ट टाइम',
    endTime: 'एन्ड टाइम',
    timeError: 'कृपया प्रारंभ समय और समाप्ति समय चुनें, और प्रारंभ समय अंतिम समय से कम होना चाहिए',
  },
  Forms: {
    agreeTips: 'कृपया पंजीकरण की शर्तें जांचें !',
    requiredFields: 'इस मद की आवश्यकता है',
    gameAccount: 'यूजरनाम',
    nameCheck: 'कृपया 6 ~ 12 अक्षर, संख्या या अक्षरों और संख्याओं का एक संयोजन दर्ज कर',
    phone: 'सेल फ़ोन नंबर',
    phoneCheck: 'प्लीज टाइप करेक्ट सेल फ़ोन नंबर ',
    email: 'ईमेल एड्रेस',
    emailCheck: 'ईमेल फॉर्मेट एरर , प्लीज रे -एंटर',
    sendCodeBefore: 'संदेश',
    sendCodeAfter: 'सेकंड',
    verifCode: 'वेरिफिकेशन कोड',
    verifCodePlace: 'टाइप वेरिफिकेशन कोड',
    oldPwd: 'ओल्ड पासवर्ड',
    newPwd: 'नई पासवर्ड',
    newPwdPlace: 'प्लीज टाइप नई पासवर्ड',
    pwdDiff: 'नया पासवर्ड पुराने पासवर्ड के समान नहीं हो सकता है!',
    repeatPwd: 'कन्फर्म नई पासवर्ड',
    repeatPwdPlace: 'प्लीज टाइप थे नई पासवर्ड अगेन',
    newDiff: 'दो नए पासवर्ड अलग हैं',
    pwdError: 'कृपया 6 ~ 12 अक्षरों, संख्याओं या अक्षरों और संख्याओं के संयोजन के साथ एक पासवर्ड दर्ज कर',
    drawPwdError: 'कृपया 4 या अधिक अक्षरों, संख्याओं या अक्षरों और संख्याओं के संयोजन के साथ एक वापसी पासवर्ड दर्ज करें',
    sendSuccess: 'सक्सेस्स्फुल्ली सेंत'
  },
  upload: {
    imgSize: 'M',
    imgSizeTxt: 'इमेज साइज',
    imgType: 'इमेज फाइल फोर्मट्स',
    select: '+ कृपया फ़ाइल अपलोड का चयन करें',
    successTips: 'सफलतापूर्वक अपलोड हो गया',
    errorTips: 'आकार से बड़ा नहीं'
  },
  service: {
    live_chat: 'Live Chat',
    whatsapp: 'Whatsapp',
    telegram: 'Telegram',
    commonProblem: 'आम समस्या'
  },
  discounts: {
    join: 'विवरण',
    queryresult: 'सर्चिंग रिजल्ट',
    userUpgrade: 'अपग्रेड क्वेरी',
    betOrderNo: 'कृपया शर्त संख्या दर्ज करें',
    needLoin: 'यू मस्ट लोग इन , फंड योर बोनस एंड  क्लेम आईटी',
    noDiscounts: 'नो अवेलेबल प्रोमोज!',
    moreDiscount: 'व्यू मोरे प्रोमोज',
    getBonus: 'बोनस का दावा करें',
    discountsReceived: 'क्लेम बोनस',
    checkPlatform: 'प्लीज सेलेक्ट प्लेटफार्म',
    checkMoney: 'प्लीज ेंटर अमाउंट',
    checkBisnum: 'प्लीज बेट स्लिप नंबर',
    userInformation: {
      userAccount: 'यूजरनाम',
      levelInfo: 'करंट टियर ',
      totalBetflow: 'टोटल अमाउंट वगेरेद',
      totalUpAmount: ' अक्सुमुलेटिंग टियर स्टेटस रेजिंग बोनस',
      totalWeekAmount: 'अक्सुमुलेटिंग वीकली वैल्यू बोनस',
      totalMonthAmount: 'अक्सुमुलेटिंग मंथली वैल्यू बोनस',
      nextLevelBetflow: 'बेटस रिक्वायर्ड फ़ोर उप्ग्रडिंग तो हायर टियर'
    },
    tips1: 'करंट  एंड  अपकमिंग  काम्पैग्न्स !',
    unlogined: {
      txt1: "फैंटास्टिक  प्रोमोशंस ",
	    txt2: "विन  अमेजिंग  प्रिज़ेंस ",
	    txt3: "हेरे  यू  विल  फंड  आवर  लेटेस्ट  एंड  ग्रेटेस्ट  प्रोमोशंस .",
	    txt4: "टैलोरेड  तो  योर  टास्ते  एंड  सुपर  इजी  तो  फंड .",
	    txt5: "बुकमार्क  थिस  पेज  एंड  नेवर  मिस  ान  ओप्पोर्तुनिटी  अगेन .",

      txt6: "चेक  बैक  हेरे  तो  फंड ",
	    txt7: "अमेजिंग  प्रोमोशंस ",
	    txt8: "ब्रांड  नई  रिवार्ड्स ",
	    txt9: "ब्रिलियंट  बांउसेस  तो  क्लेम ",
	    txt10: "ज्वाइन  नाउ  एंड  फंड  आउट  मोरे !",
	    txt11: "मोस्ट  पॉपुलर  गेम्स "
    }
  },
  // 存款
  Deposit: {
    orderTip: 'आपका जमा अनुरोध भेजा गया है',
    referralAmount: 'अनुशंसित रिचार्ज राशि',
    saveLimit: 'डिपाजिट लिमिट',
    receiptAccount: 'बेनेफिशरी अकाउंट',
    receiptAccountPlace: 'वैध लाभार्थी खाता दर्ज करें',
    saveMoneyNum: 'डेपोसिटेड अमाउंट',
    saveMoneyNumPlace: 'वैध जमा राशि दर्ज करें',
    orderName: 'डेपोसिटोर',
    orderName2: 'डेपोसिटोर',
    orderNamePlace: 'मान्य जमाकर्ता नाम दर्ज करें',
    saveCertificate: 'ट्रांसक्शन रिसीप',
    saveCertificatePlace: 'वैध लेनदेन रसीद दर्ज करें',
    payTutorial: 'पेमेंट टुटोरिअल',
    orderNumber: 'ट्रांसक्शन नंबर',
    receiptMoney: 'अमाउंट',
    receipt: 'रिसीविंग पेमेंट',
    account: 'अकाउंट नंबर',
    timer: 'सबमिट टाइम',
    finish: 'दोने ',
    base: {
      title: 'डिपाजिट',
      savaType: 'प्लीज चूसे पेमेंट मेथड',
      nonsupport: 'सॉरी , थे पेमेंट मेथड इस नॉट सपोर्टेड'
    },
    bankTransfer: {
      title: 'बैंक ट्रांसफर',
      bankAddr: 'IFSC CODE',
      bank: 'बैंक',
      beneficiary: 'बेनेफिशरी',
      account: 'बैंक अकाउंट',
      contactUs: 'कृपया ग्राहक सेवा से संपर्क करें',
      sendTips: 'योर डिपाजिट रिक्वेस्ट है बीन सेंत',
      orderMoney: 'अमाउंट',
      orderDueBank: 'बेनेफिशरी बैंक',
      oderBankName: 'अकाउंट नाम',
      transfer: 'अन्तर -बैंक ट्रांसफर',
      transferTips1: '30 मिनट के भीतर जमा राशि आपके बैलेंस में दिखाई देगी।',
      transferTips2: 'बैंक प्रेषण के आगमन के समय का वादा नहीं करता है। यदि आपकी धनराशि 24 घंटे के भीतर नहीं दिखाई देती है, तो कृपया ऑनलाइन समर्थन से संपर्क करें!',
      typeofpayment: 'भुगतान का प्रकार',
      Transferamount: 'स्थानांतरण राशि',
      TransferUSDTAmount: 'आप यूएसडीटी राशि ट्रांसफर करना चाहते हैं',
      RupeeAmount: 'रुपये की राशि मंजूर करेंगे'
    },
    Recharge: {
      title: 'लोड क्रेडिट्स',
      payType: 'पेमेंट ओप्तिओंस',
      payChannel: 'सेलेक्ट ा पेमेंट चैनल',
      channel: 'चैनल',
      bank: 'चूसे ा बैंक',
      bankPlace: 'चूसे ा पेइंग बैंक',
      selectMoney: 'सेलेक्ट अमाउंट',
      saveMoney: 'डिपाजिट अमाउंट',
      saveMoneyPlace: 'प्लीज एंटर थे डिपाजिट अमाउंट',
      fixedMoney: 'प्लीज सेलेक्ट ा फिक्स्ड अमाउंट',
      insufficient: 'इन्सुफिसिएंट बैलेंस',
      payOthersType: 'प्लीज चेंज तो ानोथेर पेमेंट मेथड',
      back: 'रेतुर्न तो कंटिन्यू लोडिंग क्रेडिट्स',
      paySuccess: 'सक्सेस्स्फुल्ली लोडेड',
      finish: 'पेमेंट कम्प्लेटेड'
    },
    Neteller: {
      title: 'Neteller',
      cost: 'FEE',
      tips: 'Your deposit request is sent'
    },
    Paytm: {
      title: 'Paytm',
    },
    Skrill: {
      title: 'Skrill'
    }
  },
  forget: {
    title: 'फॉरगॉट योर पासवर्ड',
    RetrieveSMS: 'पासवर्ड रिकवरी वाया संस',
    MailboxRetrieve: 'पासवर्ड रिकवरी वाया ईमेल',
    CustomerRetrieve: 'पासवर्ड रिकवरी वाया कस्टमर सपोर्ट',
    checking: 'वेरिफिकेशन',
    userPlace: 'प्लीज एंटर योर यूजरनाम',
    phonePlace: 'प्लीज एंटर थे कनेक्टेड सेल फ़ोन नंबर',
    emailPlace: 'प्लीज एंटर थे कनेक्टेड ईमेल एड्रेस',
    resetPwd: 'रिसेट पासवर्ड',
    tips: 'फेल्ड रेडिरेक्टिंग तो पेज ？काइंडली कांटेक्ट कस्टमर सपोर्ट >',
    tips1: 'ा संस मैसेज विथ वेरिफिकेशन कोड है बीन सेंत तो योर सेल फ़ोन .  िफ़ नॉट रेसिवेद , प्लीज क्लिक सेंड वेरिफिकेशन कोड',
    tips2: 'ा ईमेल विथ वेरिफिकेशन कोड है बीन सेंत तो योर ईमेल एड्रेस .  िफ़ नॉट रेसिवेद , प्लीज क्लिक सेंड वेरिफिकेशन कोड',
    tips3: 'नोट : थे ईमेल मिगहत बे मिस्तकें फॉर स्पैम ; प्लस आल्सो चेक थे स्पैम फोल्डर',
    submit: 'सबमिट',
    successTips1: 'पासवर्ड रिकवरी',
    successTips2: 'योर पासवर्ड वास् सक्सेस्स्फुल्ली क्रिएटेड .'
  },
  signIn: { // 签到
    signTipsReward1: 'प्रतिज्ञा के लिए हस्ताक्षर करें',
    signTipsReward2: 'साइन-इन लाभ',
    surprise: 'आश्चर्य',
    success: 'सफलतापूर्वक साइन इन करें',
    successTips: 'नकदी जमा कर सकते हैं~',
    daySign: 'डेली सिग्न इन',
    otherIncentives: 'इतर रिवार्ड्स',
    cashBonus: 'कॅश बोनस',
    currentIntegral: 'करंट रेवर्डिंग पॉइंट्स',
    sign: 'सिग्न इन',
    signed: 'आलरेडी सिगननेद इन',
    signTips1: 'यू हैवे ा पेंडिंग प्रॉफिटेबल रेवर्डिंग पॉइंट कुड बे क्लैमेड .',
    signTips2: 'यू हैवे साइंड इन कोनसेक्युटिवेली',
    signTips3: 'भगवान, आज मत भूलना! ^ _ ^',
    signTips4: 'सिग्न इन फॉर टुमारो',
    signTips5: 'साइनिंग इन टुमारो , मिस्ट्री रिवार्ड्स अरे वेटिंग फॉर यू',
    Integral: 'रेवर्डिंग पॉइंट्स',
    signInTalent: 'सिंगिंग इन एक्सपर्ट',
    awardTips1: 'कोंग्रटुलतिओन्स！',
    awardTips2: 'प्लीज कांटेक्ट कस्टमर सपोर्ट तो क्लेम योर गुड्स प्राइज',
    integralChange: 'रेवर्डिंग पॉइंट्स रिडेम्पशन',
    integral: 'रिक्वायर्ड पॉइंट्स',
    confirmChange: 'कन्फर्म थे रिडेम्पशन',
    signNow: 'सिग्न इन नाउ',
    gameOptions: [
      'कैंडी लैंड', 'आइडेंटिटी व्', 'चांदनी खजाना बॉक्स', 'डॉलफिन', 'गर्ल विथ गन्स', 'रेड ड्रैगन वाइल्ड',
      'गोल्ड फैक्ट्री', 'टॉप ट्रुप्स सेलिब्रिटीज', ' वीकिंगमनिआ', 'हाई सोसाइटी', 'ेगीपतिअन गॉडेस',
      'ज़हाओ के जिंग बाओ',
      'लाइफ ऑफ़ रिचेस', 'लॉस्ट वेगास', 'बिग व्हील', ' जिन पिंग में 2', 'बैल बैल चैस', 'गोल्ड पैंथर',
      'सुपर 888', 'सुशी बार स्लॉट', 'आगे ऑफ़ डिस्कवरी', 'मंकी स्लॉट', 'टार्ज़न', 'ग्रेट एडवेंचर',
      'फ़राओस तुंब स्लॉट', 'वेज़ ऑफ़ फार्च्यून', 'लकी पांडा स्लॉट', 'फायर रूस्टर', 'टार्ज़न',
      'एशियाई फंतासी स्लॉट', 'शाओलिन फोर्टनेस', 'थे थ्री किंगडम्स', 'ड्रीम डेट', 'इमोशन साइंस', 'फोर्बिडन थ्रोन',
      'प्लेबॉय',
    ],
    choosePrize: 'सेलेक्ट थे प्राइज यू वांट तो रिडीम',
    lackOfIntegral: 'इन्सुफिसिएंट पॉइंट्स',
    continuously: 'कोनसेक्युटिवे सिग्न इन तो ीर्ण',
    jetton: 'चिप',
    size: '₹',
    signInTab: {
      integral: 'रेवर्डिंग पॉइंट्स हिस्ट्री',
      cash: 'रिडीम कॅश बैक रिवार्ड्स',
      forRecord: 'रिडीम हिस्ट्री',
      rule: 'सिग्न इन पालिसी '
    },
    myself: 'पर्सनल',
    recordTips1: 'यू हैवे ा पेंडिंग प्रॉफिटेबल रेवर्डिंग पॉइंट कुड बे क्लैमेड',
    signDay: 'साइंड इन कोनसेक्युटिवेली',
    day: 'डे',
    dayModifier: '',
    noDataTips: 'एव्री सिंगल पॉइंट इस ा बिगनिंग ऑफ़ कैपिटल अक्सुमुलतिओं .'
  },
  mine: {
    welcome: 'वेलकम',
    visitor: 'विजिटर',
    accountManageText: 'अकाउंट मैनेज',
    bindNow: 'एक्ट नाउ तो बाँध',
    bindSuccess: 'बंधन सक्सेस',
    filtrate: 'फिल्टर',
    timers: 'टाइम',
    timeOptions: {
      '90': 'सभी',
      '1': '24 घंटे',
      '7': '7 दिन',
      '30': '1महीना'
    },
    minBaseOptions1: {
      SaveMonery: 'डिपाजिट',
      Withdrawal: 'विथड्रॉ',
      Wallet: 'वालेटी',
      StationLetter: 'वेबसाइट मैसेज'
    },
    Withdrawal: {
      mainBalance: 'मास्टर खाता शेष ',
      addBank: 'ऐड बैंक अकाउंट',
      balance: 'बैलेंस',
      detailsTitle: 'थे बैंक स्टेटमेंट',
      cash: 'कॅश आउट इस अवेलेबल',
      recharge: 'डिपाजिट',
      drawMoney: 'विथड्रॉ',
      platform: 'प्लेटफार्म',
      takeBack: 'तकबाक',
      takeBack1: 'लौटता है',
      addbankcard: {
        pageTitle: 'बैंक अकाउंट मैनेज',
        tips1: 'कांटेक्ट कस्टमर सपोर्ट िफ़ यू वांट तो अपडेट योर सेल फ़ोन नंबर',
        tips2: 'यू हैवन टी येत क्रिएटेड ट्रांसक्शन पासवर्ड , दो यू वांट सेट ा पासवर्ड ?',
        tips3: 'इन आर्डर तो ेंसुरे थे सिक्योरिटी ऑफ़ योर अकाउंट , दो यू वांट सेट ा पासवर्ड ?',
        personName: 'कार्ड होल्डर',
        personNamePlace: 'प्लीज एंटर थे कार्ड होल्डर रियल नाम',
        bankName: 'बैंक का नाम',
        bankNamePlace: 'कृपया बैंक का नाम चुनें',
        cardNumber: 'बैंक अकाउंट नंबर',
        cardNumberPlace: '10 ~ 50 अंक होना चाहिए',
        cardNumberError: 'कृपया 10 ~ 50 अंक बैंक कार्ड नंबर दर्ज करें!',
        bankBranch: 'ब्रांच कोड',
        bankBranchPlace: 'प्लीज एंटर ा वाइल्ड ब्रांच कोड',
        bankBranchPlace2: 'IFSC में 8-20 अंकों और अक्षरों का संयोजन होना चाहिए',
        bankBindPhone: 'बैंक के साथ मोबाइल नं',
        bankBindPhonePlace: 'बैंक के साथ पंजीकृत संपर्क नंबर होना चाहिए',
        withdrawPassword: 'ट्रांसक्शन पासवर्ड',
        withdrawPasswordPlace: 'प्लीज एंटर योर ट्रांसक्शन पासवर्ड'
      },
      Draw: {
        pageTitle: 'विथड्रावल',
        money: 'विथड्रावल अमाउंट',
        moneyPlace: 'एंटर विथड्रावल अमाउंट',
        pwd: 'विथड्रावल pwd',
        pwdPlace: 'एंटर विथड्रावल पव्ड',
        canDraw: 'अवेलेबल',
        drawTips1: 'विथड्रावल अमाउंट मोरे थान',
        drawTips2: 'ॉलोवबले',
        drawTips3: 'नीड विथड्रावल pwd एंड फ़ोन वेरिफिकेशन बिफोर विथड्रॉ',
        drawTips4: ', अवॉयड डिमलस',
        deleteTips1: 'डिलीट बैंक अकाउंट',
        deleteTips2: 'कांटेक्ट कस्टमर सपोर्ट तो डिलीट बैंक अकाउंट , यस और नो ?',
        phoneTitle: 'फ़ोन नंबर नॉट वेरिफ़िएड',
        phoneConfirm: 'वेरीफाई नाउ ',
        phoneCancel: 'वेरीफाई लेटर',
        pwdTitle: 'अब तक कोई निकासी पासवर्ड नहींt',
        pwdConfirm: 'जो सेटिंग नाउ',
        pwdCancel: 'जो सेटिंग लेटर',
        pwdInputTitle: 'एंटर विथड्रॉ पव्ड',
        deleteSucess: 'डिलीट सक्सेस .',
        takeBackSuccess: 'तकबाक सक्सेस',
        applySuccess: 'अप्लाई सक्सेस',
        check: {
          amount1: 'एंटर इन्टिजर नंबर बिग्गेर थान 0',
          amount2: 'इन्सुफिसिएंट बैलेंस',
          pwd: 'विथड्रॉ pwd नॉट एम्प्टी '
        }
      }
    },
    wallet: {
      title: 'वॉलेट',
      balance: 'बैलेंस',
    },
    stationLetter: {
      title: 'वेबसाइट मैसेज',
      pageTab: {
        myMessage: 'माय मैसेज',
        sendMessage: 'सेंड नई मैसेज'
      },
      myMessageTab: {
        unread: 'लेटेस्ट न्यूज़',
        read: 'रीड मैसेज'
      },
      noMsg: 'नो मैसेज',
      noMoreMsg: 'नो मोरे मेस्सगेस',
      deleteSelect: 'डिलीट सिलेक्टेड मेस्सगेस',
      deleteSuccess: 'देलेटेड सक्सेस',
      msgType: 'संदेश प्रकार',
      msgTypeOptions: {
        money: 'विथड्रॉ एंड डिपाजिट',
        discounts: 'प्रोमोशंस',
        games: 'गेम रिलेटेड',
        other: 'इतर क्वेश्चन',
        proposal: 'सुग्गेस्टिव',
        complaint: 'कंप्लेंट '
      },
      theme: 'मैं सब्जेक्ट लाइन',
      themePlace: 'इनपुट ा सब्जेक्ट लाइन',
      desc: 'कंटेंट',
      descPlace: 'इनपुट कंटेंट',
      send: 'सेंड',
      selectMsgType: 'सेलेक्ट क्वेश्चन टाइप',
      sendSuccess: 'सेंत सक्सेस'
    },
    minBaseOptions2: {
      discount: 'प्रोमोशंस',
      latestDeposit: 'जमा आदेश रिकॉर्ड',
      task: 'कार्य',
      betRecord: 'बेट रिकार्ड्स',
      merchRecord: 'ट्रांसक्शन रिकॉर्ड',
      lockAmount: 'फ्रोजेन फंड्स डिटेल्स',
      gameCollect: 'माय कलेक्शन लिस्ट',
      InviteFriends: 'इन्विते फ्रेंड्स',
      agentCenter: 'एजेंसी केंद्र',
      appDownload: 'अप्प डाउनलोड',
      affiliate: "एफिलिएट"
    },
    betRecord: {
      title: 'बेट रिकार्ड्स',
      total: 'टोटल',
      size: 'ट्रांसक्शन नंबर्स',
      betMoney: 'बेट अमाउंट',
      effectiveBet: 'वैलिड अमाउंट',
      profit: 'प्रॉफ़िट्स अमाउंट',
      gameType: 'गेम टाइप',
      platNumber: 'प्लेटफार्म कोड',
      betOrder: 'बेट आर्डर नंबर',
      betTime: 'बेट टाइम',
      settltTime: 'सिलेक्टेड टाइम ',
      customTime: 'सेल्फ-डिफाइंड टाइम',
      selectTime: 'सिलेक्टेड टाइम',
      startTime: 'स्टार्ट टाइम',
      endTime: 'एन्ड टाइम',
      timeError: 'कृपया प्रारंभ समय और समाप्ति समय चुनें, और प्रारंभ समय अंतिम समय से कम होना चाहिए',
      gameType: 'गेम टाइप्स',
      noData: 'नो स्लिप डाटा',
      gamelist: {
        '-1': 'आल',
        '1': 'स्लॉट्स',
        '2': 'लाइव कैसिनो ',
        '3': 'स्पोर्ट्स',
        '4': 'लाटरी',
        '5': 'फिश',
        '6': 'कार्ड गेम',
        '8': 'इतर'
      }
    },
    LatestDeposit: {
    	title:'नवीनतम जमा राशि',
      yes: "हाँ ",
      no: "नहीं न ",
      continuePay: "कंटिन्यू  पेमेंट",
    	cancel:'रएवोके',
      dateTimes:'ट्रांस . डेट',
      Type:'डिपाजिट  टाइप ',
      Amount:'अमाउंट',
      ID:' डिपाजिट  ID',
      Status:'स्टेटस',
      Action:'एक्शन',
      confirmTips:'कैंसिल  योर  डिपाजिट ',
      tipsTips1:'योर  एप्लीकेशन  है  बीन  रएवोकेड!',
      tipsTips2:'रिमाइंडर : मल्टीप्ल  रिक्वेस्ट  विल  डीम्ड  तो  अकाउंट  सस्पेंडेड ',
      Close:'क्लोज',
    	goDeposit:'डिपॉजिट लिस्ट पर जाएं',
    	paytips1:'यू  स्टिल  हैवे  ुनप्प्रोवेद  डिपॉजिट्स ,',
    	paytips2:'प्लीज  वेट  फॉर  अप्रूवल  और  रएवोके  योर  डिपाजिट  टिकट',
    	gamelist: {
    		'0': 'प्रोसेसिंग',
    		'1': 'सक्सीडेड',
    		'2': 'फेल्ड',
    		'3': 'कांसलेड',
    	}

    },
    tradingRecord: {
      title: 'ट्रांसक्शन रिकॉर्ड',
      tradingType: 'ट्रांसक्शन टाइप्स',
      tradingTypeOptions: {
        0: 'आल',
        1: 'सिस्टम एडजस्टमेंट',
        2: 'मेक डिपॉजिट्स',
        3: 'क्विक विथड्रॉ',
        4: 'इम्पोर्ट तो थे गेम',
        5: 'एक्सपोर्ट तो गेम',
        8: 'प्रमोशन बोनस',
        9: 'मैन्युअल डिपाजिट',
        10: 'मैन्युअल विथड्रॉ ',

        11: 'लॉटरी की खरीद',
        12: 'लॉटरी भुगतान',
        13: 'लॉटरी ऑर्डर रद्द',
        14: 'लॉटरी दैनिक कार्य',
        16: 'बेहतर एजेंट मैन्युअल रूप से जोड़ते हैं',
        17: ' खरीद यू एर शेष',
        18: 'यू एर बैलेंस रिडीम करें',
        19: 'लॉटरी की खरीद',
        20: 'लॉटरी भुगतान',
        21: 'लॉटरी ऑर्डर रद्द',

        22: 'खेल शर्त',
        23: 'खेल जीत / हार',
        24: 'खेल शर्त वापसी',

        30: 'निमंत्रण आयोग',

        40: 'शर्त',
        41: 'भुगतान',

        90: 'युक्तियाँ',
        91: 'शर्त लगाओ',
        92: ' भुगतान का अनुमान लगाएं',
        93: 'अनुमान रद्द किया गया',

        100: 'आवेदन करने वाले'
      }
    },
    tradingRecordDetails: {
      title: 'ट्रांसक्शन डिटेल्स',
      orderNumber: 'आर्डर नंबर'
    },
    lockAmount: {
      title: 'fund लॉक्ड डिटेल्स',
      rechargeTab: 'डिपाजिट लॉक',
      discountsTab: 'प्रमोशन लॉक',
      platform: 'व्होले प्लेटफार्म',
      platformPlace: 'सेलेक्ट प्लेटफार्म',
      lockStatus: 'लॉक स्टेटस',
      lockStatusPlace: 'लॉक की स्थिति चुनें',
      bonus: 'सेलेक्ट बोनस टाइप',
      bonusType: 'बोनस टाइप',
      loackAmonutOptions: {
        all: 'आल',
        lock: 'लॉक',
        unlock: 'अनलॉक',
        cancel: 'कैंसिल'
      },
      loackAmonutStatus: {
        deposit: {
          0: 'आवेदन करने वाले',
          1: 'सफलता',
          2: 'अनुत्तीर्ण होना',
          3: 'जमे हुए',
          4: 'रद्द करें '
        },
        bonus: {
          0: 'आवेदन करने वाले',
          1: 'प्रसंस्करण',
          2: 'सफलता का दावा किय',
          3: 'पतन',
          4: 'अनुत्तीर्ण होन',
          5: 'लावारिस',
          6: 'खींचा नहीं गया'
        }
      },
      bonusTypeOption: {
        all: 'सब',
        waterRebate: 'टर्नओवर बोनस',
        softLoan: 'जमा बोनस',
        rescueGold: 'छूट देना',
        upgradeAwards: 'वीआईपी अपग्रेड बोनस',
        winAwards: 'वीआईपी बोनस को फिर से हासिल करें',
        otherPreferential: 'साइन अप बोनस',
        joinPreferential: 'रेफरल बोनस'
      },
      platformOption: {
        all: 'सभी प्लेटफार्मों',
        main: 'मुख्य खाता'
      },
      loackItem: {
        capital: 'कैपिटल',
        size: '₹',
        lockMoney: 'लॉक्ड अमाउंट',
        waterComplete: 'टर्नओवर कम्प्लेटेड',
        waterTarget: 'टर्नओवर टारगेट',
        unlock: 'अनलॉक',
        bonus: 'बोनस टाइटल',
        moneyNum: 'अमाउंट',
        remainingWater: 'रेमें टर्नओवर रिक्वेस्ट',
        platform: 'प्लेटफार्म',
        unlocked: 'उनलॉकेड'
      }
    },
    invite: {
      title: 'इन्विते फ्रेंड्स',
      scan: 'स्कैन तो डाउनलोड अप्प',
      link1: 'एफिलिएट लिंक',
      link2: 'डाउनलोड अप्प',
      link3: 'रेफरल कोड',
      tips: 'उसे अन्य ऑफ़ थे रजिस्टर मेथड्स',
      activity: 'प्रमोशन डिटेल्स',
      account: 'अकाउंट',
      receive: 'रिसीव',
      received: 'प्राप्त किया',
      cashingPrize: 'बोनस प्राप्त करें',
      outDate: 'समय सीमा समाप्त',
      noActivity: 'नो प्रमोशन',
      anyWay: 'मित्र रजिस्टर विधियों में से कोई भी चुन सकता है'
    },
    accountManage: {
      title: 'अकाउंट मैनेज',
      nickName: 'निकनेम',
      name: 'रियल नाम',
      phone: 'फ़ोन नंबर',
      email: 'ईमेल',
      loginPwd: 'लॉगिन पव्ड',
      drawPws: 'विथड्रॉ pwd',
      loiginOut: 'लोग आउट',
      authe: 'अभी सत्यापित करें',
      edit: 'संपादित करें',
      setting: 'स्थापना'
    },
    verifiedAuth: {
      title: 'रियल नाम ऑथेंटिकेशन',
      tips: 'नोट: वास्तविक नाम प्रमाणीकरण पारित करने के बाद, नाम को संशोधित नहीं किया जा सकता है। नाम वापसी का असली नाम आपका असली नाम है',
      name: 'नाम',
      namePlace: 'एंटर रियल नाम',
      IDNO: 'ID नंबर',
      IDNOPlace: 'एंटर ID नंबर',
      successTips1: 'सक्सेस! बोनस रिलीज़ प्लीज चेक माय प्रमोशन 。',
      successTips2: 'सक्सेस रियल -नाम वेरिफिकेशन',
      nameValid: 'दो नॉट सेंड अगेन रियल -नाम वेरिफिकेशन . प्लीज कांटेक्ट कस्टमर सपोर्ट ！'
    },
    mobileAuth: {
      title: 'फ़ोन नंबर ऑथेंटिकेशन',
      phoneError: 'पाठ संदेश भेजने वाला मोबाइल फ़ोन नंबर प्रमाणीकरण के लिए सबमिट किए गए मोबाइल फ़ोन नंबर से मेल नहीं खाता है',
      phonePlace: 'कृपया अपना फोन नंबर दर्ज करें',
      verifCodePlace: 'एसएमएस सत्यापन कोड दर्ज करें',
      successTips: 'सक्सेस वेरिफिकेशन',
      authenticated: 'फोन नं। ने सत्यापित किया है; नहींबार-बार क्लिक करें'
    },
    emailAuth: {
      title: 'ईमेल ऑथेंटिकेशन',
      tips1: 'वे हैवे सेंत ान इ -मेल विथ ा कन्फर्मेशन लिंक तो योर ईमेल , प्लीज क्लिक थे लिंक तो कम्पलीट रजिस्ट्रेशन',
      tips2: 'टिप: सिस्टम द्वारा भेजी गई मेल को मेल ऑपरेटर द्वारा स्पैम के रूप में गलत माना जा सकता है, आप इसे इनबॉक्स और स्पैम बॉक्स में पा सकते हैं',
      email: 'ईमेल एड्रेस',
      emailError: 'इनवैलिड ईमेल',
      emailPlace: 'एंटर ईमेल एड्रेस',
      verifCodePlace: 'एंटर वेरिफिकेशन कोड',
      codeSuccess: ' सेंत वेरिफिकेशन कोड',
      successTips: 'ईमेल सक्सेस',
      authenticated: 'ईमेल को प्रमाणित कर दिया गया है, कृपया प्रमाणीकरण न दोहराएं'
    },
    editPwd: {
      title: 'लॉगिन पासवर्ड को संशोधित करें',
      tips: 'कृपया ध्यान दें कि पासवर्ड परिवर्तन पूरा होने के बाद, आपको तुरंत नए पासवर्ड के साथ फिर से लॉग इन करना होगा',
      oldPwdPlace: 'कृपया मूल लॉगिन पासवर्ड दर्ज करें',
      successTips: 'लॉगिन पव्ड सक्सेस चेंज्ड',
      loginOut: 'लोग इन अगेन'
    },
    withdrawPwd: {
      title: 'वापसी पासवर्ड बदलें',
      pwdPlace: 'पुराना पासवर्ड डालें',
      newPwdPlace: 'नया पासवर्ड दर्ज करें',
      tips: 'वापसी पासवर्ड भूल गए, कृपया ग्राहक सेवा से संपर्क करें',
      successTips: 'बनाई गई पासवर्ड सफलता वापस लें.'
    }
  },
  wheel: { // 抽奖转盘
    title: 'भाग्यशाली पहिया खेलें',
    smalltitle: 'पैसे कैसे कमाएं',
    lotteryNum: 'शेष रहे',
    lotterySize: 'आवृत्ति',
    winRecord: 'मेरा विजयी इति',
    noRecord: 'अब तक कोई जीत नहीं',
    dispatched: 'इनाम भेजा गया',
    winPrize1: 'क्या सौभाग्य है! आपने एक पुरस्कार जीता है',
    winPrize2: 'बड़ी जीत!',
    sendPrize: 'इनाम भेजा गया।कृपया लेनदेन रिकॉर्ड की जांच करें',
    prizeTips: 'दावा करने के लिए ग्राहक सहायता से संपर्क करें',
    noPrizeNum: 'शेष ड्रा की संख्या: ',
    prizeIng: 'आरेखण प्रगति। ऐसा न करेंबार-बार क्लिक करेंें',
    congratulation: 'कोंग्रटुलतिओन',
    prizeInfo: 'जानकारी जीतना',
    thanksJoin: 'भागीदारी के लिए धन्यवाद',
    lotterNeed: 'लकी ड्रॉ नोट',
    rules: 'गतिविधि नियम',
    start: 'शुरूें',
    gameName: 'भाग्य का पहिया',
    history: 'रिकॉर्ड जीतना',
    needLogin: 'आप आकर्षित करने के लिए लॉग इन कर सकते हैं !'
  },
  betting: {
    title: 'जीटी लॉटरी',
    lottery: 'लॉटरी',
    stopBet: 'बंद बाजार में दांव लगाने की अनुमति नहीं है',
    betMinAmount: 'न्यूनतम शर्त राशि',
    needLogin: 'आप अभी तक लॉग इन नहीं हुए है！',
    AvailableBalance: 'अवेलेबल बैलेंस',
    betSuccess: 'सफल सट्टेबाजी！',
    recharge: 'रिचार्ज',
    inLottery: 'खींचना',
    rule: 'रूल्स',
    issues: 'टियर',
    rules: 'बेटिंग  रूल्स',
    betSubmit: 'प्लेस  बेट',
    addcart: 'ऐड  तो  कार्ट',
    clear: 'क्लियर',
    add: 'ज्वाइन',
    totalTxt: 'टोटल',
    noselected: 'सेलेक्ट  लकी  नंबर्स ！',
    noEnoughMoney: 'नो  एनफ  बैलेंस ！',
	limitMix: "बेटिंग अमाउंट कन्नोत बे लेस्स थान मिनिमम रिक्वायर्ड अमाउंट",
    settleType: {
      all: 'आल',
      noSettle: 'उनसेतटले',
      settle: 'सेटल',
      win: 'विन',
      lose: 'लूज़'
    },
    trafficList: {
      0: 'नंबर',
      10: 'रेड',
      11: 'येलो',
      12: 'बुले',
    },
    cartHead: {
      type: 'टाइप',
      details: 'डिटेल्स',
      multiple: 'विभिन्न',
      money: 'अमाउंट'
    },
    lotteryTab: {},
    countDown: 'काउंट  डाउन',
    record: {
      title1: 'ड्रा हिस्ट्री',
      title2: 'माय बेटिंग हिस्ट्री',
      title: 'बेटिंग डिटेल्स',
      orderNo: 'टिकट्स नंबर',
      betMoney: 'बेट अमाउंट',
      dealMoney: 'अमाउंट',
      serviceAmount: 'सर्विस फी',
      drawNum: 'ड्रा नंबर',
      betNum: 'बेट नंबर',
      status: 'स्टेटस',
      rewards: 'रिवार्ड्स',
      betTime: 'बेटिंग टाइम',
      tableHead: {
        Period: 'टियर',
        Price: 'जैकपोट',
        Numbers: 'ड्रा नंबर्स',
        Result: ' रिजल्ट्स'
      },
    },
    betChart: {
      title: 'लाटरी ट्रेंड चार्ट',
      periodsNum: 'इशू',
      lotteryNum: 'लाटरी नंबर',
      statics: {
        showCount: 'शो काउंट',
        averageMiss: 'एवरेज मिस',
        miss: 'मिस',
        maxShwo: 'मैक्स शो',
        maxMiss: 'मैक्स मिस'
      },
    },
    mybetTxt: "मेरा दांव",
    seeAll: "सभी देखें ",
    amountTxt: "शर्त पर्ची",
    editAmout: "त्वरित राशि संपादित करें ",
    fast: "तेज ",
    bets: "दांव ",
    totolNum: "कुल बेट पर्ची ",
    totolAmount: "कुल बेट राशि ",
    comfirmBet: "बेट्स की पुष्टि करें",
  },
  games: {
    title: 'खेल',
    play: 'अब खेलें',
    acount: 'खेल खाता',
    amount: "राशि",
    stayTuned: 'बने रहें',
    collectSuccess: 'संग्रह की सफलता!',
    collectCancel: 'नापसंद करें!',
    hotGameType: {
      HotGame: 'शीर्ष हिट',
      Live: 'लाइव कैसीनो',
      Sport: 'खेल',
      Slot: 'स्लॉट्स',
      CatchFish: 'मछली पकड़ना'
    },
    liveType: {
      '0': 'सबें',
      '1': 'रूले',
      '2': 'एसआईसी बीओ',
      '3': 'बैकारेट',
      '4': 'ड्रैगन टाइगर',
      '5': 'ब्लैक जैक',
      '6': 'अन्य'
    }
  },

  Tasks: {
    reward: "बोनस का दावा करें",
    invite: "आमंत्रित करें",
    play: 'खेल खेलें',
    receiveSuccess: "कार्य सफलता का दावा किया！",
    receiveTips: "रिमाइंडर : िफ़  डेली  टास्क  रिवॉर्ड  दो  नॉट  क्लेम  ,आईटी  विल  बे  रिसेट ",
    finish: "पूर्ण",
    tab: {
      depositTask: "जमा कार्य",
      inviteTask: "आमंत्रण कार्य",
      gameTask: "खेल कार्य",
    }
  },
  home: {
    matchTab: {
      best: "श्रेष्ठ",
      league: "लीग",
      collect: "संग्रह"
    },
    payTitle: "जमा करने की विधि",
    links: {
      agent: "एजेंट शामिल हो रहा है",
      guide: "मार्गदर्शक",
      faq: "एफ एंड क्यू",
      rule: "नियम",
      about: "हमारे बारे में"
    },
    company: "Copyright © 2003-{year} 11ic (International) Ltd"
  },
  team: {
    title: "बोनस पाने के लिए प्रचार करें",
    size: "रु",
    size2: "हजार",
    size2_2: "लाख",
    size3: "इससे अधिक",
    videos: "वीडियो ट्यूटोरियल",
    videoTips: "आपका ब्राउज़र वीडियो प्लेबैक का समर्थन नहीं करता है। ",
    table: {
      times: "समय",
      superior: "सुपीरियर",
      amount: "रकम",
      status: "स्थिति",
      rebateAmount: "छूट राशि",
      performanceQuota: "प्रदर्शन कोटा",
      txt1: "हर दस हजार का कमीशन",

      rank: "पद",
      account: "लेखा",
      id: "आईडी",
      title: "खेल अनुभाग ",
      searchPla: "इनपुट खिलाड़ी का नाम"
    },
    tabNav: {
      promotion: "मेरे प्रचार",
      performance: "प्रदर्शन की जांच",
      directly: "लाड़ियों की पूछताछ",
      group: "टीम पूछताछ",
      invite: "मित्रों को आमंत्रित करें"
    },
    Inquiry: {
      directly: {
        searchTxt: "सीधे खिलाड़ी का नाम दर्ज करें",
        allNum: "खिलाड़ियों की कुल संख्या",
        newAdd: "आज नया रजिस्टर",
        txt1: "प्रत्यक्ष सहबद्ध प्रदर्शन"
      },
      group: {
        searchTxt: "टीम के खिलाड़ी का नाम दर्ज करें",
        allNum: "टीमों की कुल संख्या",
        newAdd: "टीम के नए अतिरिक्त",
        txt1: "खिलाड़ियों की संख्या",
        txt2: "टीम का प्रदर्शन आज"
      }
    },
    CommissionRecordTitle: "कमीशन वापसी का रिकॉर्ड",
    promotion: {
      withdrawalTips1: "कृपया इनपुट वापसी राशि 0 से अधिक है",
      withdrawalTips2: "आपका कमीशन सफल हुआ",
      info: {
        ID: "मेरा नाम",
        superiorID: "सुपीरियर नाम",
        temNums: "टीम के सदस्यों की संख्या (नए अतिरिक्त)",
        toDayPerformance: "टीम आज का प्रदर्शन",
        players: "खिलाड़ियों की संख्या (नए अतिरिक्त)",
        todayDirectPerformance: "प्रत्यक्ष संबद्ध प्रदर्शन आज",
        yesterdayCommission: "कल आयोग",
        TodayCommission: "आज आयोग",
        tips: "सीधे संबद्ध + आयोग की टीम के बराबर कमीशन"
      },
      commission: {
        nums: "दावा करने के लिए तैयार आयोग",
        total: "कुल कमीशन",
        withdrawal: "कमीशन वापसी",
        record: "नाम वापसी का रिकॉर्ड",
        ratio: "कमीशन अनुपात",
        tutorial: "पदोन्नति ट्यूटोरियल"
      },
      inviteTips: "दोस्तों को आमंत्रित करें, आप हर दिन नकद बोनस कमा सकते हैं!",
      inviteLink: "निमंत्रण लिंक",
      inviteCode: "आमंत्रण संकेत",
      withdrawalAmount: "राशि वापस लेने के लिए: ",
      tutorial: {
        list1: [
          {
            txt: "कैसे पैसा बनाने के लिए बढ़ावा देने के लिए?",
            desc: "QR कोड स्कैन करें या आमंत्रण लिंक पर क्लिक करें, इसे ब्राउज़र में खोलने के लिए चुनें, गेम डाउनलोड करने के लिए पंजीकरण करें, और इसे बढ़ावा देने के लिए अपने अनन्य QR कोड ईवेंट आमंत्रण लिंक का उपयोग करें।"
          },
          {
            txt: "प्रचार निमंत्रण कोड कहां है?",
            desc: "दोस्तों को आमंत्रित करने के लिए क्लिक करें, और आपके पास अपना विशिष्ट क्यूआर कोड और पंजीकरण लिंक होगा। इस तरह से पंजीकृत सदस्य आपके प्रत्यक्ष खिलाड़ी और डाउनलाइन बन सकते हैंआपके द्वारा आमंत्रित किए गए सदस्य आपके प्रत्यक्ष टीम के सदस्य होंगे। और भी कई, असीमित विकास प्राप्त किया जा सकता है।"
          },
          {
            txt: "रिपोर्ट और कमीशन की जाँच कहाँ करें?",
            desc: "टीम पेज आपकी टीम के सदस्यों, टीम कंपनी की शुद्ध जीत, प्रत्यक्ष सदस्यों, प्रत्यक्ष सहबद्ध प्रदर्शन, इतिहास कुल आयोग और उपलब्ध कमीशन और इतने पर जांच कर सकता है।"
          },
          {
            txt: "प्रदर्शन की गणना कैसे करें?",
            desc: "प्रदर्शन खिलाड़ियों के वैध दांव को दर्शाता है। उदाहरण के लिए, आप एक खिलाड़ी को आमंत्रित करते हैं, वह 500 जीतता है और अगली शर्त पर 300 हार जाता है, उसका प्रदर्शन 800 है।"
          },
          {
            txt: "जमा और निकासी की आवश्यकता?",
            desc: "सदस्य केंद्र में जमा, जब 1 बार टर्नओवर खत्म हो तो निकासी उपलब्ध है।"
          },
          {
            txt: "कैसे हटेंगे?",
            desc: "सबसे पहले, टीम पेज में कमीशन से वॉलेट में स्थानांतरण करें, फिर वापस लेने के लिए आगे बढ़ें। जिस बैंक कार्ड को आप वापस लेना चाहते हैं। उसका नाम और कार्ड सही होना चाहिए या सफलतापूर्वक वापस नहीं लिया जाएगा।"
          },
          {
            txt: "कमीशन भुगतान के लिए कब तक?",
            desc: "कमीशन का क्रेडिट दैनिक होगा। प्रत्येक दिन 23:59 बजे रीसेट किया जाएगा। प्रदर्शन के आधार पर कमीशन कमीशन टेबल बेस को संदर्भित करेगा।"
          }
        ],
        proxyTips: "सहबद्ध आयोग अनुपात तालिका",
        list2: [
          {
            txt: "कमीशन की गणना",
            descList: [
              "प्रत्यक्ष एजेंट कमीशन = कुल कमीशन अनुपात * प्रत्यक्ष सहबद्ध प्रदर्शन",
              "टीम कमीशन = (कुल कमीशन अनुपात-प्रत्यक्ष सहयोगी आयोग अनुपात) * टीम का प्रदर्शन",
              "एक आयोग = (B1direct संबद्ध आयोग + B1 टीम आयोग) + B2direct संबद्ध आयोग + B3diret सहबद्ध commssion",
              "बी 1 आयोग = सी 2 प्रत्यक्ष सहयोगी आयोग + सी 3 प्रत्यक्ष सहयोगी आयोग"
            ]
          },
          {
            txt: "कुल कमीशन",
            descList: ["कुल कमीशन = प्रत्यक्ष सहयोगी आयोग + टीम आयोग"]
          },
          {
            txt: "निपटान का समय",
            descList: ["योग ने हर दिन समझौता किया, दैनिक प्रदर्शन के आधार पर कमीशन।"]
          }
        ]
      }
    },
    performance: {
      tabData: {
        today: "आज",
        yesterday: "बिता हुआ कल"
      },
      totalBetAmount: "सभी प्रदर्शन",
      selfBetAmount: "प्रत्यक्ष सहबद्ध प्रदर्शन",
      teamBetAmount: "टीम प्रदर्शन",
      tips: "सहबद्ध, टीम, सभी लाभ तुम्हारा के रूप में बनाया है",
      detailsTitle: "खेल अनुभाग "
    },
    RebateRatio: { // 返佣比例
      title: "कमीशन अनुपात",
      tableTxt1: "दैनिक टीम का प्रदर्शन",
    }
  },
  match: {
    InsufficientBalance : "मुख्य खाता शेष अपर्याप्त है, कृपया पहले रिचार्ज करें !",
    more: "अधिक",
    nodata: "और कोई मेल नहीं",
    multiples: "सभी गुणक",
    clear: "स्पष्ट शर्त",
    betTotalMoney: "शर्त लगाएं",
    back: "लौटता है",
    winner: "विजेता",
    locked: "बंद कर दिया",
    autoOdds: "ऑटो नवीनतम ऑड प्राप्त करते हैं",
    autoOddsTips: "चयन के बाद, टिकट की सफलता दर बढ़ जाएगी, और ऑड्स टिकटिंग बाधाओं (टिकटिंग बाधाओं के रूप में प्रस्तुत की गई बाधाओं के आधार पर हो सकता है)",
    done: "किया हुआ",
    limitMax: "अधिकतम शर्त राशि पार हो गई",
    betResult: "सफलतापूर्वक सबमिट करें!",
    betRecord: "सट्टेबाजी इतिहास खोज",
    continueBet: "सट्टेबाजी जारी रखें",
    betAmount: "दांव की संख्या",
    noBetTips: "कृपया शर्त राशि की पुष्टि करें",
    draw: "आकर्षित करना",
    success: "सफलता",
    failure: "असफलता",

    records: {
      tips: "अनुस्मारक: वर्तमान पृष्ठ केवल GT क्रिकेट, BTI, IBC, EXCHANGE सट्टेबाजी रिकॉर्ड के सट्टेबाजी रिकॉर्ड को प्रदर्शित करता है, कृपया अन्य खेलों में देखें",
      nodata: "अभी तक कोई डेटा नहीं है, खेलना जारी रख",
      toBet: "अंदाज़ करना",
      otherGame: "अन्य खेल",
      items: {
        eventName: "कार्यक्रम नाम",
        gametName: "गेम का नाम",
        content: "सट्टेबाजी की सामग्री",
        betAmount: "बेट राशि",
        odds: "अंतर",
        revenue: "राजस्व",
        status: "स्थिति",
        orderNo: "आदेश संख."
      },
      status: {
        '99': "असंतोषजनक",
        '100': "बसे हुए",
        '1': "जीत",
        '0': "खोना",
        '-1': 'धन की वापसी'
      },
    }
  },
  ghistory: {
		title: 'Bet Detail',
    Playerid: 'Player ID',
    gameid: 'Game ID',
    insurance: 'insurance',
    WinorLoss: 'कुल जीत / हार',
		betTime: 'बेट टाइम',
		orderNo: 'Txn. ID',
    Status: 'स्थिति',
    Provider: 'Provider',
    Event: 'Event',
    betArea: 'Bet area',
    gameName: 'Game name',
    total: "कुल",
    Odds: 'Odds',
    TotalBets: 'कुल दांव',
    ValidBets: 'Valid Bets',
    WinorLoss2: 'Win/Loss',
    close: 'बंद करे',
    Running: 'Running',
    Settled: 'बसे हुए',
	}
}
export default hi_IN



// WEBPACK FOOTER //
// ./src/pages/build902/i18n/langs/hi_IN.js